import { useEffect } from 'react';
import useUserStore from '@/lib/hooks/zustand-stores/use-user-store'
import { acceptNewTeam } from '@/app/actions/teams'
import { useLogger } from '@/lib/hooks/useLogger'
import { toast } from '@/lib/toast'

export function TeamInviteHandler() {
  const logger = useLogger();
  const mixusUserId = useUserStore(state => state?.user?._id)
  const teamInviteId = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('teamInviteId')
    : null;

  useEffect(() => {
    const handleJoinTeam = async () => {
      if (teamInviteId && mixusUserId) {
        try {
          const res = await acceptNewTeam(teamInviteId);
          if (res.success) {
            toast.info(`Team invitation accepted successfully`, { duration: 10000 });
            logger.info(`user ${mixusUserId} successfully joined team ${teamInviteId}`);
            return;
          }

          if (res.notInvited) {
            toast.error(
              "This invite link belongs to another user. Please sign up directly or use your personal invite link.",
              { duration: 10000 }
            );
          } else if (res.isValid === false) {
            toast.error(
              `This team invitation isn't valid anymore, please reach to your inviter.`,
              { duration: 10000 }
            );
          } else if (res.isAlreadyActivated) {
            toast.error(
              `This team invitation was already activated.`,
              { duration: 10000 }
            );
          }
        } catch (error) {
          logger.error('Error saving referral:', error);
        }
      }
    };

    handleJoinTeam();
  }, [mixusUserId, teamInviteId]);

  return null;
}
